import React from "react";
import CircularProgress from "../../../../components/CircularProgress";
import { LoadingTextStyle } from "../../style";

const Loading = () => {
  return (
    <LoadingTextStyle>
      <CircularProgress />
    </LoadingTextStyle>
  );
};

export default Loading;
